import { Skeleton } from "@mui/material";
import { useGetHanpassReceiptQuery } from "app/apiSlice";
import Layout from "components/layout/Layout";
import { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useNavigate, useParams } from "react-router-dom";
import { providerClasses } from "utils/tailwindUtils";

const formatDateString = (dateString: string): string => {
  const year = dateString.slice(0, 4);
  const month = dateString.slice(4, 6);
  const day = dateString.slice(6, 8);
  const hour = dateString.slice(8, 10);
  const minute = dateString.slice(10, 12);
  const second = dateString.slice(12, 14);

  return `${year}.${month}.${day} ${hour}:${minute}:${second}`;
};

const HanpassReceipt = () => {
  const navigate = useNavigate();
  const { paymentId = "" } = useParams();
  const { data, isFetching, isError } = useGetHanpassReceiptQuery(paymentId);

  if (isError) {
    navigate(-1);
    return;
  }

  const lastTransactionDate = data?.payHistory[0].regDate;

  return (
    <Layout text={<FormattedMessage id="hanpass.receipt" />}>
      <div className="mt-4 w-full space-y-4 bg-white p-2 py-4 [&_td]:border-[1px] [&_td]:border-gray-300 [&_td]:p-1 [&_td]:font-bold [&_th]:border-[1px] [&_th]:font-normal">
        <h1
          className={`text-center text-2xl font-bold ${providerClasses["text-primary"]}`}
        >
          <FormattedMessage id="hanpass.receipt.title" />
        </h1>

        <div className="space-y-2">
          <p className="font-bold">
            [
            <FormattedMessage id="hanpass.receipt.paymentInfo" />]
          </p>
          <table className="w-full border-collapse break-keep border-[1px] border-gray-300">
            <tbody>
              <tr>
                <th>
                  <FormattedMessage id="hanpass.receipt.product" />
                </th>
                <td>
                  {isFetching ? (
                    <Skeleton variant="text" className="h-full min-w-[50vw]" />
                  ) : (
                    `${data?.orderName}`
                  )}
                </td>
              </tr>
              <tr>
                <th>
                  <FormattedMessage id="hanpass.receipt.method" />
                </th>
                <td>
                  {isFetching ? (
                    <Skeleton variant="text" className="h-full min-w-[50vw]" />
                  ) : (
                    <FormattedMessage id="hanpass.receipt.hanpassWallet" />
                  )}
                </td>
              </tr>
              <tr>
                <th>
                  <FormattedMessage id="hanpass.receipt.date" />
                </th>
                <td>
                  {isFetching ? (
                    <Skeleton variant="text" className="h-full min-w-[50vw]" />
                  ) : (
                    formatDateString(lastTransactionDate!)
                  )}
                </td>
              </tr>
              <tr>
                <th>
                  <FormattedMessage id="hanpass.receipt.status" />
                </th>
                <td>
                  {isFetching ? (
                    <Skeleton variant="text" className="h-full min-w-[50vw]" />
                  ) : (
                    <FormattedMessage
                      id={
                        data?.status === "COMPLETE"
                          ? "hanpass.receipt.completed"
                          : "hanpass.receipt.cancelled"
                      }
                    />
                  )}
                </td>
              </tr>
              <tr>
                <th>
                  <FormattedMessage id="hanpass.receipt.price" />
                </th>
                <td className="text-error">
                  {isFetching ? (
                    <Skeleton variant="text" className="h-full min-w-[50vw]" />
                  ) : (
                    `${data?.payAmount.toLocaleString()} ${data?.payCurrency}`
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="space-y-2">
          <p className="font-bold">
            [<FormattedMessage id="hanpass.receipt.providerInfo" />]
          </p>
          <table className="w-full border-collapse break-keep border-[1px] border-gray-300 text-sm">
            <tbody>
              <tr>
                <th>
                  <FormattedMessage id="hanpass.receipt.providerName" />
                </th>
                <td>
                  <FormattedMessage id="hanpass.receipt.lacha" />
                </td>
                <th>
                  <FormattedMessage id="hanpass.receipt.providerNumber" />
                </th>
                <td>657-88-00880</td>
              </tr>
              <tr>
                <th>
                  <FormattedMessage id="hanpass.receipt.providerCEOName" />
                </th>
                <td>
                  <FormattedMessage id="hanpass.receipt.providerCEO" />
                </td>
                <th>
                  <FormattedMessage id="hanpass.receipt.providerContact" />
                </th>
                <td>02-568-1220</td>
              </tr>
              <tr>
                <th>
                  <FormattedMessage id="hanpass.receipt.providerAddress" />
                </th>
                <td colSpan={3}>
                  <FormattedMessage id="hanpass.receipt.providerAddressDetail" />
                </td>
              </tr>
            </tbody>
          </table>
          {/* <div className="grid grid-cols-12 border-[1px] border-gray-300 text-xs [&>p:nth-child(2n)]:font-bold [&>p:nth-child(odd)]:text-gray-500 [&>p]:border-[1px] [&>p]:border-gray-300 [&>p]:p-1">
            <p className="col-span-2">공급자상호</p>
            <p className="col-span-4">주식회사 라쿠카라차</p>

            <p className="col-span-3">사업자등록번호</p>
            <p className="col-span-3">657-88-00880</p>

            <p className="col-span-2">대표자명</p>
            <p className="col-span-4">이윤상</p>

            <p className="col-span-3">고객센터</p>
            <p className="col-span-3">025080611</p>

            <p className="col-span-2">주소</p>
            <p className="col-span-10">
              서울시 강남구 선릉로86길 26, 4층(대치동, 신안빌딩)
            </p>
          </div> */}
        </div>
      </div>
    </Layout>
  );
};

export default HanpassReceipt;
